<mat-card-title class="full-width" fxLayout="row">
    <span>{{data.title}}</span>
</mat-card-title>
<div class="pb-1 popup-width">
    <mat-divider></mat-divider>
</div>
<form [formGroup]="unos">
    <div fxLayout="column" fxLayoutGap="20px">
        <mat-form-field>
            <mat-label>{{ translatePrefix + "datumDeaktiviranja" | translate }}</mat-label>
            <input formControlName="datumDeaktiviranja" data-testid="submissionDateFrom" matInput
                [matDatepicker]="submissionFrom" [min]="minDate" />
            <mat-datepicker-toggle matSuffix [for]="submissionFrom"></mat-datepicker-toggle>
            <mat-datepicker #submissionFrom></mat-datepicker>

            <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear" matTooltipPosition="above"
                (click)="this.datumDeaktiviranja.reset()">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="datumDeaktiviranja.invalid" class="alert">
                <span *ngIf="datumDeaktiviranja.errors['required']">
                    {{translatePrefix + "obaveznoPolje" | translate:
                    {attributName: translatePrefix + "datumDeaktiviranja" | translate} }}
                </span>
                <span *ngIf="datumDeaktiviranja.errors['matDatepickerMin']">
                    {{ (translatePrefix + "datumNeSmeBitiManjiOd" | translate : { minDatum: (minDate | date:'d.MM.yyyy.') }) }}
                </span>
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <textarea matInput placeholder="{{
                translatePrefix + 'razlogDeaktivacije' | translate
              }}" formControlName="razlogDeaktivacije" maxlength="1000" rows="2"></textarea>
            <mat-error *ngIf="razlogDeaktivacije.invalid" class="alert">
                <span *ngIf="razlogDeaktivacije.errors['required'] || razlogDeaktivacije.errors['whitespace']">
                    {{translatePrefix + "obaveznoPolje" | translate:
                    {attributName: translatePrefix + "razlogDeaktivacije" | translate} }}
                </span>
            </mat-error>
        </mat-form-field>

        <h3>{{data.message}}</h3>
    </div>

    <div fxLayout="row" fxLayoutGap="20px" class="pt-1">
        <div fxFlex="50" fxLayoutGap="20px">
            <button data-testid="btnObrisi" class="full-width" mat-raised-button color="primary"
                (click)="confirm($event)">
                <mat-icon>done</mat-icon>
                {{ translatePrefix + "deaktiviraj" | translate }}
            </button>
        </div>

        <div fxFlex="50" fxLayoutGap="20px">
            <button data-testid="btnOtkazi" class="full-width white-button" (click)="cancel()" mat-raised-button>
                <mat-icon>close</mat-icon>
                {{ "general.cancel" | translate }}
            </button>
        </div>
    </div>
</form>